import React, { Component } from "react";
import "./Skills.css";
import { Fade } from "react-reveal";
import Img1 from "./mesh04.png";
import Img2 from "./mesh05.png";
import Img3 from "./mesh06.png";
import Img4 from "./mesh07.png";

const SkillSection = (props) => {
  console.log(props);
  return (
    <div>
      {props.animation && (
        <div className="two_by_two_grid">
          <div className="skill_div" style={{ marginTop: "100px" }}>
            <div className="skills-main-div">
              <Fade right duration={2000}>
                <div className="skills-image-div">
                  <img src={Img1} alt="value1" />
                </div>
              </Fade>
              <div className="skills-text-div">
                <Fade left duration={1000}>
                  <h1
                    className="skills-heading"
                    style={{ color: props.theme.text }}
                  >
                    {props.value1}
                  </h1>
                </Fade>
                <Fade left duration={2000}>
                  <div>
                    <h2
                      className="def_class"
                      style={{ color: props.theme.secondaryText }}
                    >
                      {props.def1}
                    </h2>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
          <div className="skill_div" style={{ marginTop: "100px" }}>
            <div className="skills-main-div">
              <div className="skills-text-div">
                <Fade right duration={3000}>
                  <h1
                    className="skills-heading"
                    style={{ color: props.theme.text }}
                  >
                    {props.value2}
                  </h1>
                </Fade>
                <Fade right duration={3500}>
                  <div>
                    <h2
                      className="def_class"
                      style={{ color: props.theme.secondaryText }}
                    >
                      {props.def2}
                    </h2>
                  </div>
                </Fade>
              </div>
              <Fade left duration={2000}>
                <div className="skills-image-div">
                  <img src={Img2} alt="value2" />
                </div>
              </Fade>
            </div>
          </div>
          <div className="skill_div" style={{ marginTop: "100px" }}>
            <div className="skills-main-div">
              <Fade right duration={2000}>
                <div className="skills-image-div">
                  <img src={Img3} alt="value3" />
                </div>
              </Fade>

              <div className="skills-text-div">
                <Fade left duration={3000}>
                  <h1
                    className="skills-heading"
                    style={{ color: props.theme.text }}
                  >
                    {props.value3}
                  </h1>
                </Fade>
                <Fade left duration={3500}>
                  <div>
                    <h2
                      className="def_class"
                      style={{ color: props.theme.secondaryText }}
                    >
                      {props.def3}
                    </h2>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
          <div className="skill_div" style={{ marginTop: "100px" }}>
            <div className="skills-main-div">
              <div className="skills-text-div">
                <Fade right duration={3000}>
                  <h1
                    className="skills-heading"
                    style={{ color: props.theme.text }}
                  >
                    {props.value4}
                  </h1>
                </Fade>
                <Fade right duration={3500}>
                  <div>
                    <h2
                      className="def_class"
                      style={{ color: props.theme.secondaryText }}
                    >
                      {props.def4}
                    </h2>
                  </div>
                </Fade>
              </div>
              <Fade left duration={2000}>
                <div className="skills-image-div">
                  <img src={Img4} alt="value4" />
                </div>
              </Fade>
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "15px",
          textAlign: "center",
          marginBottom: "30px",
        }}
      >
      </div>
    </div>
  );
};

export default SkillSection;
